export default {
    create: {
        cancelButton: {
            buttons: ['Отказать в возврате', 'Вернуться к оформлению', 'Подтверждаю'],
            text: 'Подтвердите отказ в возврате и укажите причину:',
        },

        create: {
            headerTitle: 'Внимание!',
            // eslint-disable-next-line max-len
            alert: 'C даты выдачи заказа № {id} (выдан: {dateDone}) с онлайн-оплатой прошло более 7 дней! По Закону возврат онлайн-заказа производится в течение 7 дней!',
            h3: 'Данные отправлены!',
            textNotProduct: 'Не указано количество возвращаемого товара.',
            textNotProductOrNotCommentToCustomer: 'Должно быть указано количество возвращаемого товара и комментарий покупателю.',
            okTitle: 'Подтверждаю',
            cancelTitle: 'Вернуться к оформлению',
            bvModal: 'Подтвердите завершение оформления возврата. После подтверждения скорректировать данные будет невозможно.',
        },

        form: {
            fields: {
                orderId: 'Заказ №',
                refundFio: 'ФИО клиента',
                refundPhone: 'Телефон клиента',
                typeAccount: 'Тип расчета',
                checkingAccount: 'Расчетный счет',
                bankName: 'Наименование банка',
                bik: 'БИК',
                correspondentAccount: 'Корреспондентский счет',
                refundReason: 'Причина возврата',
                commentToCustomer: {
                    label: 'Комментарий покупателю',
                    tooltip: 'Заполнять поле только в случае отказа в возврате',
                },
            },

            typeAccount: {
                details: 'Банковские реквизиты',
                card: 'Карта',
                cardViaTerminal: 'Карта через терминал',
            },
        },

        formCreate: 'Поле обязательно для заполнения!',
    },

    details: {
        fields: {
            order: 'Заказ №',
            pfm: 'ПФМ',
            initiator: 'Инициатор операции',
            client: 'Клиент',
            refundReason: 'Причина возврата',
            partnerName: 'Источник заказа',
            payTypeName: 'Способ оплаты заказа',
            payerName: 'Имя клиента',
            payerPhone: 'Контактный телефон клиента',
            refundType: 'Способ возврата средств',
            deliveryServiceMethodName: 'Способ доставки',
            checkingAccount: 'Расчётный счёт',
            bankName: 'Наименование банка',
            correspondentAccount: 'Корреспондентский счёт',
            orderRefundSap: 'Номер возврата SAP',
        },

        index: {
            order: 'Операция по возврату заказа № {orderId}',
            products: 'Итого сумма возврата',
            totalToBeReturned: 'Итого к возврату',
            delivery: 'Доставка',
            goodsAmount: 'Сумма товаров',
        },
    },

    filter: {
        notFound: 'Найдено {count} операций | Найдена {count} операция | Найдено {count} операции | Найдено {count} операций',
    },

    index: {
        refundCheck: 'Оформление возврата',
        refundList: 'Список операций по возврату',
        actualReturn: 'Возврат от курьерской службы',
        returnFromKuperVitrina: 'Возврат из маркетплейса Купер',
        taskToReturnFromKuperVitrina: 'Задача на возврат из маркетплейса Купер',
        taskToReturnFromDostavista: 'Задача на возврат из Достависты',
        taskToReturnFromShipping: 'Задача на возврат из доставки {description}',
        partners: 'Партнеры',
        refundYandex: 'Возвраты Я.Еда',
    },

    kuperVitrinaFields: {
        order: 'Заказ',
        originalOrder: '№ заказа Купер',
        pfm: 'Код магазина ПФМ',
        status: 'Статус',
        action: 'Действие',
    },

    yandex: {
        loadFile: 'Загрузка файла реестра',
        availableFormats: 'Доступные форматы: XLSX',
        errorFile: 'Ошибка загрузки файла. Повторите попытку.',
        order: 'Заказ №',
        confirmRefund: 'Подтвердить возврат',
        refundAccepted: 'Возврат принят',
        allRefundsConfirmed: 'Все возвраты из реестра подтверждены. Завершить работу с реестром?',
        refundsNotConfirmed: 'Не все заказы подтверждены. Вы уверены, что хотите закрыть страницу?',
        refundInformer: 'Заказ №{orderId} уже подтвержден',
        allRefundsConfirmedBefore: 'Возвраты по этим заказам уже приняты, перейти к просмотру операций?',
        fields: {
            sku: 'ЛК',
            productName: 'Наименование',
            refundQuantity: 'Штуки',
            refundCost: 'Сумма',
        },
        totalFields: {
            orders: 'Кол-во заказов с возвратами',
            sum: 'Сумма по всем возвратам, RUB',
            productsQuantity: 'Общее количество товара, шт',
            unacceptedOrders: 'Кол-во непринятых заказов, шт',
            correctionOrders: 'Кол-во заказов с бух. корректировками',
        },
        acceptAllRefunds: 'Принять все возвраты',
        transactionDate: 'Дата проводки',
        transactionDateWarning: 'Дата проводок не должна быть позднее даты перечисления ДС по реестру',
        total: 'Итого:',
        collapse: 'Свернуть',
        expand: 'Развернуть',
        refund: 'Возврат',
        accountingAdjustments: 'Бухгалтерские корректировки',
        refundCollapsed: 'Возврат {count} шт. {sum} руб.',
        accountingAdjustmentsCollapsed: 'Бухгалтерская корректировка {count} шт. {sum} руб.',
    },

    print: {
        info: 'Заявление на возврат с доставкой',
        content: [
            'Генеральному директору \n',
            'Общество с ограниченной ответственностью «Бэст Прайс»\n',
            'Погонину В.П.\n',
            'от _________________________________________________\n',
            '(ФИО полностью)\n',
            'паспорт серия ______№_________________________\n',
            'выдан: кем ____________________________________\n',
            'когда   «    »______________________________г.\n',
            'телефон _______________________________________',
            'ЗАЯВЛЕНИЕ НА ВОЗВРАТ ТОВАРА',
            'Я _____________________________________________________________________________________________',
            'приобрел (а) в вашем магазине по заказу № ________________ товар: \n',
            'что подтверждается кассовым чеком _______________________ ФД ___________________________',
            'Указанный товар ____________________________________________________________________________',
            '(причина возврата)',
            'Прошу вернуть уплаченную за товар денежную сумму в размере \n',
            '__________ руб. ________ коп.',
            '(сумма прописью)',
            'Банковским переводом на реквизиты:',
            'Наименование банка: _______________________________________________________________________',
            'БИК банка: __________________________________________________________________________________',
            'Номер расчетного счета: ____________________________________________________________________',
            'Дата',
            'Подпись',
            'Расшифровка подписи',
        ],

        buttonPdf: 'Печать заявления на возврат с доставкой',
    },

    areYouSure: 'Вы точно хотите подтвердить возврат?',

    actual: {
        fields: {
            type: 'Тип задачи',
            priority: 'Приоритет',
            status: 'Статус',
        },
        service: {
            priority: 'Высокий',
            status: 'Не выполнена',
        },
    },

    fieldsView: {
        orderId: 'Заказ',
        pfm: 'Код магазина ПФМ',
        tare: 'Тары в заказе',
        orderStatus: 'Статус',
        printTransfer: 'Передаточные документы',
        partnerOrder: '№ заказа партнёра',
        actions: 'Действие',
    },

    error: {
        action: 'Не удалось выполнить действие',
    },

    filterFields: {
        orderId: 'Номер заказа',
        pfm: 'Код магазина ПФМ',
        deliveryService: 'Служба доставки',
    },
};